import { Injectable } from '@angular/core';
import { psImage } from "../models/psImage";

@Injectable({
  providedIn: 'root'
})

export class PsImagesService {

  private psImages: Array<psImage>;

  constructor() {
    this.setImages();
  }

  setImages() {
    this.psImages = [
      {id: 1, name: '25’ away from PS showing general surroundings of PS', url: ''},
      {id: 2, name: 'Before maintenance starts, show open door view of PS and all batteries', url: ''},
      {id: 3, name: 'Picture of PS display of MAC', url: ''},
      {id: 4, name: 'If no display is available or it’s an External Transponder, picture of sticker', url: ''},
      {id: 5, name: 'Picture of string of batteries that shows separation, wiring and Temp probe', url: ''},
      {id: 6, name: 'Battery date stamp', url: ''},
      {id: 7, name: 'Coaxial ground block in PS cabinet to include input RF', url: ''},
      {id: 8, name: 'PS ground', url: ''},
      {id: 9, name: 'Commercial power outlet showing LAP and PS connector', url: ''},
      {id: 10, name: 'Repeat step 2 after work is completed', url: ''},
      {id: 11, name: 'Power Company Electric Meter', url: ''}
    ]
  }

  getImages() {
    return this.psImages;
  }
}
